import {
  Box,
  Chip,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import "../../App.css";
import React, { useEffect, useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import dayjs from "dayjs";
import { TableNodata } from "../../components/TableNodata";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../api/client";
import HistoryIcon from "@mui/icons-material/History";
import SearchIcon from "@mui/icons-material/Search";
import { TableLoader } from "../../components/TableLoader";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Person } from "@mui/icons-material";
import CustomPagination from "../../components/CustomPagination";
import ManageSearchOutlinedIcon from "@mui/icons-material/ManageSearchOutlined";

const UserReview = () => {
  const [showTable, setShowTable] = useState(false);
  const [page, setPage] = useState(+localStorage.getItem("currentPage") || 0);
  const [rowsPerPage, setRowsPerPage] = useState(
    +localStorage.getItem("rowsPerPage") || 10
  );
  const navigate = useNavigate();
  const [listData, setListData] = useState([]);
  const [count, setCount] = useState(0);
  const [searchKey, setSearchKey] = useState(
    localStorage.getItem("searchvalue") || ""
  );
  const [selectedTab, setSelectedTab] = useState(
    +localStorage.getItem("TabValue") || 0
  );
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userId = userData?.user_id;
  const [loding, setLoding] = useState(false);

  const location = useLocation();
  const { user_Id, dashboard, studentName, viewAssessments } =
    location.state || {};
  const headers = [
    { label: "S.No", align: "center", key: "sno" },
    { label: "Subject", align: "left", key: "category" },
    { label: "Level", align: "left", key: "level" },
    { label: "Total Mark", align: "left", key: "topics" },
    { label: "Created Date", align: "left", key: "created_at" },
    { label: "Submitted Date", align: "left", key: "submitted_at" },
    { label: "Attempt Status", align: "left", key: "attempt_status" },
    { label: "Actions", align: "left", key: "actions" },
  ];

  //==== Handlers ====
  const handleSearch = (e) => {
    localStorage.setItem("currentPage", 0);
    setPage(0);
    localStorage.setItem("searchvalue", e.target.value);
    setSearchKey(e.target.value);
  };

  const handleTabChange = (event, newValue) => {
    localStorage.setItem("TabValue", newValue);
    setSelectedTab(newValue);
    setPage(0);
    setSearchKey("");
    setListData([]);
  };

  const fetchData = async () => {
    setLoding(true);
    try {
      const payload = {
        user_id: user_Id ? user_Id : userId,
        page: page,
        size: rowsPerPage,
        search_key: searchKey,
      };

      if (
        localStorage.getItem("role") === "STUDENT" ||
        localStorage.getItem("role") === "SUPER_ADMIN" ||
        localStorage.getItem("role") === "INSTITUTE_ADMIN" ||
        localStorage.getItem("role") === "TRAINER"
      ) {
        if (selectedTab === 0) {
          const res = await api.post("StudentSelfAssessmentHistory", payload);
          if (res?.data?.status === "success") {
            setListData(res.data?.data || []);
            setCount(res.data?.count || 0);
          } else {
            console.error(res?.data?.message || "Failed to fetch");
          }
        } else if (selectedTab === 1) {
          const res = await api.post(
            "StudentProctoredAssessmentHistory",
            payload
          );
          if (res?.data?.status === "success") {
            setListData(res.data?.data || []);
            setCount(res.data?.count || 0);
          } else {
            console.error(res?.data?.message || "Failed to fetch");
          }
        }
      }
    } catch (err) {
      console.log("Error:", err);
      setLoding(false);
    } finally {
      setLoding(false);
    }
  };

  //==== useEffect ====
  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, searchKey, selectedTab]);

  useEffect(() => {
    if (
      localStorage.getItem("role") !== "STUDENT" ||
      localStorage.getItem("role") !== "SUPER_ADMIN"
    ) {
      localStorage.setItem("TabValue", "0");
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowTable(true);
    }, 200); // 0.2 sec delay

    return () => clearTimeout(timer);
  }, []);

  return (
    <Box sx={{ minHeight: "100vh", p: 1 }}>
      {dashboard === true && (
        <Grid
          item
          sx={{
            display: "flex",
            alignItems: "center",
            color: "#1c97e3",
            gap: "4px",
            cursor: "pointer",
            width: "fit-content",
            mb: 2,
          }}
          role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                window.history.back();
              }
            }}
            onClick={() => window.history.back()}
        >
          <ArrowBackIcon sx={{ fontSize: "17px" }} />
          <Typography
            sx={{ fontWeight: 600, fontSize: "14px", color: "#1c97e3" }}
          >
            Back
          </Typography>
        </Grid>
      )}
      {/* Back Button */}
      {dashboard ||
        (viewAssessments && (
          <Grid
            item
            sx={{
              display: "flex",
              alignItems: "center",
              color: "#1c97e3",
              gap: "4px",
              cursor: "pointer",
              width: "40px",
              marginBottom: "20px",
            }}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                window.history.back();
              }
            }}
            onClick={() => window.history.back()}
          >
            <ArrowBackIcon sx={{ fontSize: "17px" }} />
            <Typography
              sx={{ fontWeight: 600, fontSize: "14px", color: "#1c97e3" }}
            >
              Back
            </Typography>
          </Grid>
        ))}
      <Grid
        sx={{
          display: "flex",
          justifyContent: "space-between",
          // borderBottom: "1px solid #828487",
          pb: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 0.5,
            alignItems: "center",
          }}
        >
          <Box className="icon-box">
            <HistoryIcon sx={{ color: "#1976d2", fontSize: "28px" }} />
          </Box>
          {/* Title */}
          <Typography sx={{ fontSize: { xs: 20, sm: 28 }, fontWeight: 700, color: "#0a0a0a" }}>
            Assessment History
          </Typography>
        </Box>
        <Box>
          <TextField
            value={searchKey}
            onChange={(e) => handleSearch(e)}
            size="small"
            variant="outlined"
            placeholder="Search Subject"
            className="custom-search-field"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Grid>

      {/* === Tabs === */}
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 2,
        }}
      >
        {localStorage.getItem("role") !== "STUDENT" && (
          <Box>
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              aria-label="trainer tabs"
            >
              <Tab
                label="Self Assessments"
                sx={{ textTransform: "none", fontWeight: "bold", fontSize: 16 }}
              />
              <Tab
                label="Proctored Assessments"
                sx={{ textTransform: "none", fontWeight: "bold", fontSize: 16 }}
              />
            </Tabs>
          </Box>
        )}
        {viewAssessments && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <IconButton>
              <Person sx={{ fontSize: 20, color: "#1976d2" }} />
            </IconButton>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "bold",
                color: "#1976d2",
              }}
            >
              {studentName}
            </Typography>
          </Box>
        )}
      </Box>

      <Box>
        <TableContainer
          component={Paper}
          sx={{
            opacity: showTable ? 1 : 0,
            transform: showTable ? "translateY(0)" : "translateY(40px)", // start from bottom
            transition: "opacity 0.5s ease, transform 0.5s ease",
          }}
        >
          <Table>
            {/* ✅ Dynamic Table Head */} 
            <TableHead sx={{ backgroundColor: "#e8f0fe" }}>
              <TableRow>
                {headers.map((head, index) => (
                  <TableCell
                    key={index}
                    align={head.align || "left"}
                    className="tableHeader"
                  >
                    <b>{head.label}</b>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {loding ? (
              <TableCell colSpan={8} align="center">
                <TableLoader message="Fetching assessment history..." />
              </TableCell>
            ) : (
              <TableBody className="tablebody">
                {listData.map((item, index) => (
                  <TableRow
                    key={index}
                    hover
                    sx={{
                      backgroundColor: index % 2 === 1 ? "#FAFAFA" : "inherit",
                      "&:hover": { backgroundColor: "#f1f1f1" },
                    }}
                  >
                    {/* ✅ S.No should reflect pagination */}
                    <TableCell align="center">
                      {page * rowsPerPage + index + 1}
                    </TableCell>
                    <TableCell>{item.category}</TableCell>
                    <TableCell>
                      <Chip
                        label={item.level}
                        size="small"
                        variant="outlined"
                        color="primary"
                        sx={{ fontWeight: 500 }}
                      />
                    </TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          display: "inline-block",
                          backgroundColor: "#1976d2", // blue background
                          color: "#fff", // white text
                          fontWeight: "bold",
                          borderRadius: "12px",
                          padding: "2px 8px", // small padding for badge look
                          minWidth: "40px",
                          textAlign: "center",
                        }}
                      >
                        {item.final_score}/100
                      </Box>
                    </TableCell>

                    {/* ✅ Created Date in DD-MM-YYYY */}
                    <TableCell>
                      {item?.created_at
                        ? dayjs(item.created_at).format("DD-MM-YYYY")
                        : "-"}
                    </TableCell>

                    {/* ✅ Submitted Date in DD-MM-YYYY hh:mm A */}
                    <TableCell>
                      {item?.submitted_at
                        ? dayjs(item.submitted_at).format("DD-MM-YYYY hh:mm A")
                        : "-"}
                    </TableCell>

                    <TableCell>
                      {item.attempt_status === "COMPLETED"
                        ? "✅ Completed"
                        : item.attempt_status || "-"}
                    </TableCell>
                    <TableCell align="center">
                      {/* <Tooltip
                        title="View"
                        arrow
                        componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: "primary.main",
                              color: "white",
                              fontSize: 13,
                              fontWeight: 500,
                            },
                          },
                          arrow: {
                            sx: {
                              color: "primary.main",
                            },
                          },
                        }}
                      > */}
                      <IconButton
                        color="primary"
                        onClick={() =>
                          navigate("/examOverview", {
                            state: {
                              assessmentId: item.assessment_id,
                              attemptId: item.attempt_id,
                              studentId: item?.student_user_id,
                              studentName: studentName,
                            },
                          })
                        }
                        sx={{
                          display: "flex",
                          // alignItems: "center",
                          gap: 0.5,
                        }}
                      >
                        <ManageSearchOutlinedIcon />
                        <Typography color="primary" sx={{ fontSize: "12px" }}>
                          Assessment History
                        </Typography>
                      </IconButton>
                      {/* </Tooltip> */}
                    </TableCell>
                  </TableRow>
                ))}

                {((page === 0 && listData?.length > rowsPerPage - 1) ||
                  page !== 0) && (
                  <CustomPagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    setPage={setPage}
                    count={count}
                    colSpan={8}
                  />
                )}

                {listData?.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={headers.length} align="center">
                      <TableNodata />
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default UserReview;
